"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _chunk2 = _interopRequireDefault(require("lodash/chunk"));

var _proptypes = require("../../services/proptypes");

var _CTA = _interopRequireDefault(require("./CTA"));

var _utils = require("./utils");

require("./CallToActionBanner.css");

/* eslint-disable react/no-array-index-key */
function CallToActionBanner(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      textAlign = _ref.textAlign,
      verticalAlign = _ref.verticalAlign,
      extraProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "columns", "textAlign", "verticalAlign"]);
  var childrenCount = children.length;

  if (childrenCount === 0) {
    return null;
  }

  var cols = Math.min(columns || childrenCount, 16);
  var rowsWithChildren = (0, _chunk2["default"])(children, cols);
  var extraClasses = [(0, _utils.getTextAlignClass)(textAlign), (0, _utils.getVerticalAlignClass)(verticalAlign)].join(' ');
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, (0, _extends2["default"])({
    className: "cta-banner ".concat(extraClasses),
    columns: cols
  }, extraProps), rowsWithChildren.map(function (rowChildren, idx) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
      columns: rowChildren.length,
      key: "cta-banner-row-".concat(idx),
      className: "cta-banner-row"
    }, rowChildren);
  }));
}

CallToActionBanner.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),
  columns: _propTypes["default"].number,
  textAlign: _proptypes.TextAlignPropType,
  verticalAlign: _proptypes.VerticalAlignPropType
};
CallToActionBanner.defaultProps = {
  columns: null,
  children: [],
  textAlign: 'center',
  verticalAlign: 'middle'
};
CallToActionBanner.CTA = _CTA["default"];
var _default = CallToActionBanner;
exports["default"] = _default;